import moment from 'moment';
import { getUsers } from '../../HttpRequests/users';
import { loadUsers } from '../State/users';

let lastGetTimestamp = null;

const cacheTTL = 60000;

export default ({ force } = {}) => async (dispatch) => {

  try {

    if (!force && lastGetTimestamp) {

      const now = Number(moment().format('x'));

      if (now < (lastGetTimestamp + cacheTTL)) return;
    }
      
    lastGetTimestamp = Number(moment().format('x'));

    const params = {
      'filter[isnt_subcontractor]': 1,
      sort: 'first_name',
      pagination: 0,
    }

    const response = await getUsers({ params });

    dispatch(loadUsers(response.data));

  } catch (error) {
    
    throw error;

  }
}